import React, { createContext, useContext, useState } from "react";

// Create a context to store the active tab
const TabsContext = createContext();

export const Tabs = ({ children, defaultValue }) => {
    const [activeTab, setActiveTab] = useState(defaultValue);
    
    return (
        <TabsContext.Provider value={{ activeTab, setActiveTab }}>
            <div className="w-full">{children}</div>
        </TabsContext.Provider>
    );
};

export const TabsList = ({ children }) => (
    <div className="flex justify-center bg-gray-100 p-2 rounded-lg shadow-md">
        {children}
    </div>
);

export const TabsTrigger = ({ value, children }) => {
    const { activeTab, setActiveTab } = useContext(TabsContext);

    return (
        <button
            className={`px-6 py-3 font-semibold text-lg transition-all duration-300 rounded-lg
                ${
                    activeTab === value
                        ? "bg-blue-600 text-white shadow-md"
                        : "bg-gray-200 text-gray-600 hover:bg-gray-300"
                }
            `}
            onClick={() => setActiveTab(value)}
            style={{
                width: "50%",
                height: "auto",
                padding: "10px 20px",
                backgroundColor: activeTab === value ? "#f9f9f9" : "white",
                color: activeTab === value ? "#333" : "#333",
                border: "none",
                borderRadius: "0px",
                cursor: "pointer",
                marginTop: "10px",
                transition: "background-color 0.3s ease",
                fontSize: "16px",
                fontWeight: "bold",
            }}
        >
            {children}
        </button>
    );
};

export const TabsContent = ({ value, children }) => {
    const { activeTab } = useContext(TabsContext);
    return activeTab === value ? <div className="p-4">{children}</div> : null;
};
